import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPage } from "../analytic";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPage(location.pathname + location.search);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
